import React from "react";
import T from "prop-types";
import { Map } from "immutable";
import { Field } from "redux-form";
import { Row, Col } from "react-bootstrap";
import SearchCompany from "MODULES/companies/shared/SearchCompany";
import {
  REASONS,
  CUSTOMER_RMA_REASONS
} from "MODULES/RMAsAndWarranties/constants";
import {
  Form as AppForm,
  FormInput,
  Select
} from "MODULES/shared/components/Forms";
import { toOptions } from "LIB/forms";

export default function Form(props) {
  return (
    <AppForm {...props}>
      <AppForm.Body>
        <Row className="row-col-gutters-half">
          <Col md={6}>
            <Field
              component={SearchCompany}
              name="company_id"
              company={props.rma.toJS().company}
            />
          </Col>
          <Col md={6}>
            <Field
              name="reason"
              component={Select}
              label="Reason"
              options={toOptions(
                props.rma.get("type") === "VendorRma"
                  ? REASONS
                  : CUSTOMER_RMA_REASONS
              )}
              prompt={false}
              required
            />
          </Col>
        </Row>
        <Row className="row-col-gutters-half">
          <Col md={6}>
            {props.rma.get("type") === "CustomerRma" &&
            props.customerRmaReasons === "other" ? (
              <Field
                name={"other_reason"}
                component={FormInput}
                label="Other-Reason"
                required
              />
            ) : (
              ""
            )}
            {props.rma.get("type") === "VendorRma" ? (
              <Field
                component={FormInput}
                name="vendor_rma_number"
                label="Vendor RMA Number"
              />
            ) : (
              ""
            )}
          </Col>
        </Row>
      </AppForm.Body>
    </AppForm>
  );
}

Form.propTypes = {
  rma: T.instanceOf(Map).isRequired
};



// WEBPACK FOOTER //
// ./app/modules/RMAsAndWarranties/components/Detail/Panel/Details/Form.jsx